import { render, staticRenderFns } from "./Mlabel.vue?vue&type=template&id=a1e6b588&scoped=true&"
import script from "./Mlabel.vue?vue&type=script&lang=js&"
export * from "./Mlabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e6b588",
  null
  
)

export default component.exports